// frontend/src/pages/RedefinirSenhaConfirmarPage/RedefinirSenhaConfirmarPage.jsx

import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Image } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import authService from '../../services/authService';
import logo from '../../assets/images/logo_vertical.jpg'; // Importando a logo
// 1. IMPORTAÇÃO DO TRATAMENTO DE ERRO
import { getErrorMessage } from '../../utils/errorHandler';
import '../../styles/auth.css';

const { Title } = Typography;

const RedefinirSenhaConfirmarPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // O Django envia o uid e o token na URL
  const { uid, token } = useParams();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await authService.confirmarResetSenha(uid, token, values.password, values.confirm);
      message.success('Senha alterada com sucesso!');
      // Redireciona para o login após 2 segundos
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      console.error(error);
      // 2. USO NO CONFIRMAR RESET
      message.error(getErrorMessage(error, 'O link é inválido ou expirou. Tente solicitar novamente.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <Card className="auth-card">
        
        <Image
          width={180}
          src={logo}
          alt="Logo Saldo Ativo"
          preview={false}
          className="auth-logo"
        />

        <div style={{ marginBottom: 24 }}>
          <Title level={3} className="auth-title">
            Nova Senha
          </Title>
          <p className="auth-subtitle">Crie uma nova senha segura para sua conta.</p>
        </div>

        <Form
          name="reset_confirm"
          onFinish={onFinish}
          size="large"
          autoComplete="off"
        >
          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Insira a nova senha!' }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Nova Senha" />
          </Form.Item>

          <Form.Item
            name="confirm"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Confirme a nova senha!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('As senhas não coincidem!'));
                },
              }),
            ]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder="Confirmar Nova Senha" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Alterar Senha
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default RedefinirSenhaConfirmarPage;